<script lang="ts">
    import EmojiPicker from './EmojiPicker.svelte';
    import type { Emoji } from '$components/Emoji/EmojiPicker.svelte';
    import { fly } from 'svelte/transition';
    import { quadOut, quartInOut } from 'svelte/easing';
    import StackZIndex from '$components/ZIndex/StackZIndex.svelte';
    import { createPopover, melt } from '@melt-ui/svelte';

    let className = '';
    export { className as class };

    export let onSelect: (emoji: Emoji) => void = () => {};

    export let autocloseAfterSelect: boolean = true;

    let {
        elements: { trigger, content },
        states: { open },
    } = createPopover();

    function onSelect_(emoji: Emoji) {
        onSelect(emoji);
        if (autocloseAfterSelect) {
            $open = false;
        }
    }

    function transitionIn(node: Element) {
        return fly(node, {
            delay: 0,
            duration: 150,
            easing: quadOut,
            y: -5,
            opacity: 0.5,
        });
    }

    function transitionOut(node: Element) {
        return fly(node, {
            delay: 0,
            duration: 150,
            easing: quartInOut,
            y: 5,
            opacity: 0.5,
        });
    }
</script>

<button
    use:melt={$trigger}
    aria-label="Emoji"
    class={className}
    on:click|preventDefault={() => {}}
>
    <slot><i class="tnp tnp-emoji" aria-hidden={true}></i></slot>
</button>

{#if $open}
    <StackZIndex zIndex="inc" let:zIndex>
        <section
            use:melt={$content}
            in:transitionIn
            out:transitionOut
            class="z-[--z-index]"
            style={`--z-index: ${zIndex}`}
        >
            <EmojiPicker onSelect={onSelect_} />
        </section>
    </StackZIndex>
{/if}
